let client = {
  Severity: {
    Info: 'INFO',
  },
  scope: {
    extra: [],
    tags: [],
    setTag(name, value) {
      this.tags.push({ name, value })
    },
    setExtra(name, value) {
      this.extra.push({ name, value })
    },
  },
  withScope(fn) {
    if (typeof fn !== 'function') return
    fn(this.scope)
    console.log('[SENTRY] withScope', this.scope)
  },
  configureScope(fn) {
    if (typeof fn !== 'function') return
    fn(this.scope)
    console.log('[SENTRY] configureScope', this.scope)
  },
  componentDidCatch(error, errorInfo) {
    console.log('[SENTRY] componentDidCatch', error, errorInfo)
  },
  captureException(...args) {
    console.log('[SENTRY] captureException', ...args)
  },
  addBreadcrumb(category, message) {
    console.log('[SENTRY] addBreadcrumb', category, message)
  },
}

export class SentryWrapper {
  static initialize(sentry) {
    client = sentry
  }

  static componentDidCatch(error, errorInfo) {
    client.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key])
      })
      client.captureException(error)
    })
  }

  static captureException(...args) {
    client.captureException(...args)
  }

  static setTag(name, value) {
    client.configureScope(scope => {
      scope.setTag(name, value)
    })
  }

  static addBreadcrumb(category, message) {
    let data = null
    if (typeof message === 'object') {
      data = message
      message = null
    }
    client.addBreadcrumb({
      category,
      message,
      data,
      level: client.Severity.Info,
    })
  }
}
